module.exports = __webpack_public_path__ + "img/information.49573299.png";